import { CoreModule, NAVIGATE_TO_MANAGE_PROFILE } from '@abp/ng.core';
import { registerLocale } from '@abp/ng.core/locale';
import { provideThemeBasicConfig, ThemeBasicModule } from '@abp/ng.theme.basic';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DashboardComponent } from './dashboard/dashboard.component';
import { InvoiceDetailComponent } from './invoice-detail/invoice-detail.component';
import { MessagesComponent } from './messages/messages.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BaseUrlInterceptor } from './interceptors/http-interceptor';
import { PaymentComponent } from './payment/payment.component';

@NgModule({
  providers: [
    provideThemeBasicConfig(),
    { provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor, multi: true },
    { provide: NAVIGATE_TO_MANAGE_PROFILE, useValue: () => {} }
  ],
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    CoreModule.forRoot({
      environment,
      registerLocaleFn: registerLocale(),
      skipInitAuthService: true
    }),
    ThemeSharedModule.forRoot(),
    ThemeBasicModule.forRoot()
  ],
  declarations: [
    AppComponent,
    DashboardComponent,
    InvoiceDetailComponent,
    MessagesComponent,
    PaymentComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
